import './lib/lib-flexible'
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router/index'
import store from './store/index';
import 'element-ui/lib/theme-chalk/index.css';
// main.js 或其他入口文件
import AppDatePicker from '@/components/common/AppDatePicker.vue'


// 引入富文本编辑器
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css

// 引入全局错误处理工具
import { 
    handleApiError, 
    handleError, 
    handleNetworkError, 
    handleValidationError,
    createErrorHandler 
} from './utils/handleError.js'


// 引入基础工具
import { getProjectTypeName, timeUtils, TENDER_FILE_TYPE } from './utils/base.js'

// 引入文件预览工具
import filePreviewUtil from './utils/previewFile.js'

// 引入渠道素材管理工具
import channelMaterial, { CHANNEL_ID } from './utils/channelMaterial.js'

import lang from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale';
locale.use(lang);

Vue.config.productionTip = false

Vue.use(ElementUI);

// Vue.prototype.$ELEMENT = {
//   zIndex: 3000
// }

// 注册富文本编辑器组件
Vue.component('Editor', Editor)
Vue.component('Toolbar', Toolbar)

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

// 挂载全局错误处理方法到Vue原型上
Vue.prototype.$handleApiError = handleApiError
Vue.prototype.$handleError = handleError
Vue.prototype.$handleNetworkError = handleNetworkError
Vue.prototype.$handleValidationError = handleValidationError
Vue.prototype.$createErrorHandler = createErrorHandler

// 挂载基础工具到Vue原型上
Vue.prototype.$getProjectTypeName = getProjectTypeName
Vue.prototype.$timeUtils = timeUtils
Vue.prototype.$tenderFileType = TENDER_FILE_TYPE

Vue.component('AppDatePicker', AppDatePicker)

// 挂载文件预览工具到Vue原型上
Vue.prototype.$filePreview = filePreviewUtil

// 挂载渠道素材管理工具到Vue原型上
Vue.prototype.$channelMaterial = channelMaterial
Vue.prototype.$channelId = CHANNEL_ID

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
